import { render, staticRenderFns } from "./SpaceList.vue?vue&type=template&id=71b9e0e8&scoped=true"
import script from "./SpaceList.vue?vue&type=script&lang=ts"
export * from "./SpaceList.vue?vue&type=script&lang=ts"
import style0 from "./SpaceList.vue?vue&type=style&index=0&id=71b9e0e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b9e0e8",
  null
  
)

export default component.exports